import { PowerupId } from "@/shared/data/powerups";
import { AvatarAnimation } from "@/shared/types/animation";
import { AvatarReaction } from "@/shared/types/avatar";
import { StreamChatMessage } from "@/shared/types/chat";

export type RuntimeEventMap = {
  likesChanged: { total: number; delta: number };
  likeClicked: { amount: number };
  viewersChanged: { real: number; botted: number; total: number };
  animationPlayed: { animationId: AvatarAnimation };
  giftSpawned: { amount: number };
  chatSpawned: {};
  badCommentSpawned: {};
  chatMessageSpawned: { message: StreamChatMessage };
  chatMessageModerated: { message: StreamChatMessage };
  chatMessageExpired: { message: StreamChatMessage };
  powerupPurchased: { powerupId: PowerupId; level: number };
  avatarReaction: { reaction: AvatarReaction };
  runWon: {};
};

type Unsubscribe = () => void;

export class EventBus<TEvents extends Record<string, any>> {
  private listeners: {
    [K in keyof TEvents]?: Array<(payload: TEvents[K]) => void>;
  } = {};

  on<K extends keyof TEvents>(
    event: K,
    handler: (payload: TEvents[K]) => void,
  ): Unsubscribe {
    const arr = (this.listeners[event] ??= []);
    arr.push(handler);

    return () => {
      this.listeners[event] = arr.filter((fn) => fn !== handler);
    };
  }

  emit<K extends keyof TEvents>(event: K, payload: TEvents[K]) {
    for (const fn of this.listeners[event] ?? []) {
      fn(payload);
    }
  }
}
